import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { provideValueAccessor } from '@sama/ng-core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AbstractFormControl } from '../../../shared/forms/basic-inputs/abstract-form-control';

export interface ToggleButton<T extends string | number = string> {
  value: T;
  label?: string;
  icon?: IconDefinition;
  iconTransform?: string;
  template?: TemplateRef<any>;
  tooltip?: string;
  disable?: string;
  contextualClassWhenActive?: string;
  visible$?: Observable<boolean>;
}

@Component({
  selector: 'h3-toggle-button-group',
  templateUrl: './toggle-button-group.component.html',
  styleUrls: ['./toggle-button-group.component.scss'],
  providers: [provideValueAccessor(ToggleButtonGroupComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToggleButtonGroupComponent extends AbstractFormControl<
  string | number | null
> {
  @Input({ required: true }) buttons!: Array<ToggleButton<string | number>>;
  @Input() size?: 'sm' | 'xs';
  @Input() fillArea = false;
  @Input() vertical = false;
  @Input() uncheckable = false;
  @Output() buttonClick = new EventEmitter<void>();
  value$ = new BehaviorSubject<string | number | null>(null);

  contextualClass(button: ToggleButton<string | number>) {
    if (
      this.value$.getValue() === button.value &&
      button.contextualClassWhenActive
    ) {
      return button.contextualClassWhenActive;
    }

    return '';
  }

  onClick({ value, disable }: ToggleButton<string | number>) {
    if (disable) {
      return;
    }
    if (value === this.value$.getValue()) {
      if (this.uncheckable) {
        this.setValue(null);
      }
    } else {
      this.setValue(value);
      this.buttonClick.emit();
    }
  }

  handleIncomingValue(value: string | number | null) {
    this.value$.next(value);
  }

  setValue(value: string | number | null) {
    this.value$.next(value);
    this.emitOutgoingValue(value);
  }
}
